//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[0,"InsertStripTog",1,0],[0,"PartMatStr",1,0],[0,"PartThickReal",1,0],[0,"PartUnitStr",1,0],[0,"PathName",1,0],[0,"ProjPathStr",1,0],[0,"ProjTempOpt",1,0],[0,"ProjectName",1,0],[0,"RenameDiaTog",1,0],[1,"StationaryFace",0,"ScCollector",0],[0,"UseSmfeatTog",1,0]],[[[],"ProjPathButton",{},0,0],[[],"MatLibButton",{},0,0],[[],"ProjTempBut",{},0,0],[["templateName"],"InitNewProject",{},1,0],[["partNames","radId"],"InitInsertPartsToProject",{},2,0],[[],"OpenChangeMaterial",{},0,0],[[],"OpenChangeThickness",{},0,0],[[],"HideOriginalParts",{},0,0],[["count","attrNameList"],"AskAttributeData",{R_:{attrValueList:""}},0,0],[["attributeName","attributeValue"],"UpdateProjectAttribute",{},2,0],[["controlPart"],"AssignProjectAttributes",{},1,0]],[]];
SPLM.Tooling.InitProjBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.InitProjBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.InitProjBuilder.ProjTempOption = Object.freeze({
    "Default" : "Default"});

export default SPLM;